<template>
  <div>
    <supplier-filters
      :name.sync="payload.name"
      :postcode.sync="payload.postcode"
      :approved.sync="payload.approved"
      :active.sync="payload.active"
      @apply="getSuppliers(payload)"
    ></supplier-filters>
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Suppliers</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="suppliers"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :page.sync="pagination.page"
            :options.sync="pagination"
            :items-per-page.sync="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0 black--text"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:item.amount="{ item }">
              {{ parseInt(item.amount, 10).toFixed(2) }}
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
import SupplierFilters from "./SupplierFilters.vue";
export default {
  components: {
    SupplierFilters
  },
  mixins: [Helpers],
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Phone",
          align: "left",
          value: "phone",
          sortable: false
        },
        {
          text: "Address",
          align: "left",
          sortable: false,
          value: "address"
        },
        {
          text: "APT NO",
          align: "left",
          value: "aptNo"
        },
        {
          text: "State",
          align: "left",
          value: "state"
        },
        {
          text: "Post Code",
          align: "left",
          value: "postcode"
        },
        {
          text: "Country",
          align: "left",
          value: "country"
        },
        { text: "", value: "action", align: "right" }
      ],
      payload: {
        from: 0,
        to: 10,
        name: " ",
        active: null,
        approved: null,
        postcode: " "
      }
    };
  },
  computed: {
    suppliers() {
      return this.$store.state.suppliers.suppliers;
    },
    totalItems() {
      return this.$store.state.suppliers.totalSuppliers;
    }
  },
  created() {
    this.getSuppliers(this.payload);
  },
  methods: {
    getSuppliers(payload) {
      this.loading = true;
      this.$store
        .dispatch("suppliers/LOAD_SUPPLIERS", payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      let payload = this.payload;
      payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getSuppliers(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getSuppliers(payload);
      }
    }
  }
};
</script>
